module.exports = __webpack_public_path__ + "img/menu-white.9043b3e2.svg";